<ng-container [ngTemplateOutlet]="img ? withImage : withoutImage"></ng-container>

<ng-template #withImage>
  <div class="main-wrap-with-image {{bgColor}}">
    <div class="header" (click)="toggle()">
      <div>
        <img [src]="img" />
        <span [innerHTML]="title"></span>
      </div>
      <i class="db-icon db-icon-ds-arrow-small arrow" [ngClass]="{'rotate': toggled}"></i>
    </div>
    <div class="content" [innerHTML]="body"></div>
  </div>
</ng-template>

<ng-template #withoutImage>
  <div class="main-wrap-without-image {{bgColor}}">
    <div class="header" (click)="toggle()">
      <div>
        <i class="db-icon db-icon-ds-close-bg"></i>
        <span [innerHTML]="title"></span>
      </div>
      <i class="db-icon db-icon-ds-arrow-small arrow" [ngClass]="{'rotate': toggled}"></i>
    </div>
    <div class="content" [innerHTML]="body"></div>
  </div>
</ng-template>
